module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kyushu-ea9ec288a307061dc96a65a3a259df8b.png";